<template>
  <div id="organuser">
    <!-- {{PlugJson}} -->
    <van-collapse v-model="activeName" accordion>
      <van-collapse-item title="标题1" :name="0">
        <template
          slot="title"
        >{{(PlugJson.PlugBody.OrganUserCount)?'机构工作人员'+PlugJson.PlugBody.OrganUserCount+'人':'未登记机构工作人员信息'}}</template>
        <van-cell v-for="(item,index) in PlugJson.PlugBody.OrganUserList" :key="index">
          <template slot="title">
            <i class="fa fa-user"></i>
            <b>{{item.RealName}}</b>
            <small>{{(item.UserSexText) ?' ('+item.UserSexText+')' : ''}}</small>
          </template>
          <template slot="default">
            <span class="fa fa-fw fa-phone color-blue"></span>
            <a class="color-blue" :href="'tel:'+item.Phone">
              <!-- {{item.Phone}} -->
            </a>
          </template>
        </van-cell>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  name: "organuser",
  props: {
    PlugJson: Object
  },
  data() {
    return {
      activeName: 1
    };
  }
};
</script>

<style scoped>
</style>